var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"grow",attrs:{"type":_vm.buttonType ? _vm.buttonType : 'button'},on:{"click":(event) => {
			if (_vm.shouldStopPropagation) {
				event.stopPropagation();
			}
			_vm.handleClick();
		}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }